import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Breadcrumbs from '../features/components/Breadcrumbs'
import PartnershipSelectorPreview from '../features/components/PartnershipSelector/PartnershipSelectorPreview'
import { TabletUp } from '../components/hoc/ResponsiveRendering'
import UserMenu from '../features/components/Header/AuthorizedHeader/UserMenu'

import { getAppDomainName } from '../features/helpers/getAppDomainName'

import { isAccountSetupModeSelector } from '../modules/selectors/app'
import { partnershipsSelector, selectedPartnershipSelector } from '../modules/selectors/partnerships'

import useStyles from './styles'

function Page({
  helmetTitle,
  breadcrumbs,
  onBackButtonClick,
  showBackBtn,
  className,
  mainClassName,
  additionalPartnershipInfo,
  showPartnershipShortInfo,
  showPartnershipInfo = true,
  children
}) {
  const classes = useStyles({ hasSideBar: true })

  const { t } = useTranslation()

  const appName = getAppDomainName()

  const partnerships = useSelector(partnershipsSelector)
  const isAccountSetupMode = useSelector(isAccountSetupModeSelector)
  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const hasPartnerships = !!partnerships.length
  const { short_intro: partnershipShortInfo } = selectedPartnership

  useEffect(() => {
    if (window.analytics) {
      // call Segment analytics on every authorized page
      window.analytics.page()
    }

    // revert scroll to top on new page open
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Helmet>
        <title>
          {t(helmetTitle)} · {appName}
        </title>
      </Helmet>
      <main className={classnames(classes.main, mainClassName)}>
        <div className={classes.container}>
          {/* data-html2canvas-ignore is added to fix case when Partnerhsip logo is not accessible/loaded */}
          <div className={classes.headingContainer} data-html2canvas-ignore>
            <div className={classes.leftHeadingColumn}>
              {breadcrumbs && (
                <Breadcrumbs
                  routes={breadcrumbs}
                  onBackButtonClick={onBackButtonClick}
                  showBackBtn={showBackBtn}
                  className={classes.breadCrumbs}
                />
              )}
              {/*there is case when we use page without having partnerships or during user account setup*/}
              {!isAccountSetupMode && hasPartnerships && showPartnershipInfo && (
                <PartnershipSelectorPreview additionalPartnershipInfo={additionalPartnershipInfo} />
              )}
              {showPartnershipShortInfo && partnershipShortInfo && (
                <div className={classes.partnershipShortInfo}>{partnershipShortInfo}</div>
              )}
            </div>
            <TabletUp>
              <UserMenu />
            </TabletUp>
          </div>
        </div>
        <div className={classnames(classes.container, className)}>{children}</div>
      </main>
    </>
  )
}

export default Page

Page.propTypes = {
  helmetTitle: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.array,
  breadcrumbsBackBtn: PropTypes.node,
  className: PropTypes.string,
  mainClassName: PropTypes.string,
  additionalPartnershipInfo: PropTypes.string,
  showPartnershipShortInfo: PropTypes.bool,
  showPartnershipInfo: PropTypes.bool,
  children: PropTypes.node
}
